// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XQHS","tabsBox":"styles_tabsBox__2Vl9K","createButton":"styles_createButton__3m3QY"};